// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"54493474","239":"456a8e6c","252":"267f103c","384":"dddc048f","565":"7de1e3e5","629":"03543d77","807":"bbc6d14d","811":"bc7c071c","929":"95fec4a6","989":"51b61467"}[chunkId] + ".chunk.js";
};